import { render, staticRenderFns } from "./ReturnGoods.vue?vue&type=template&id=5cf630b3&scoped=true&"
import script from "./ReturnGoods.vue?vue&type=script&lang=js&"
export * from "./ReturnGoods.vue?vue&type=script&lang=js&"
import style0 from "./ReturnGoods.vue?vue&type=style&index=0&id=5cf630b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf630b3",
  null
  
)

export default component.exports